import Head from "next/head";
import { useState, useEffect } from "react";

import { defaultDescription, defaultTitle, iosLink, webLink } from "const/links";

import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";

const APP_STORE_ID = "1517031842";

const structuredData = {
	"@context": "https://schema.org",
	"@type": "SoftwareApplication",
	name: "Wishbox",
	applicationCategory: "FinanceApplication",
	operatingSystem: "iOS, iPadOS, macOS, watchOS. Android and Wear OS coming soon",
	offers: {
		"@type": "Offer",
		price: "0",
		priceCurrency: "USD"
	},
	description: defaultDescription,
	url: webLink,
	downloadUrl: iosLink,
	author: {
		"@type": "Person",
		name: "Kostas Filios"
	}
};

export default function Layout({ title, description, children }) {
	const [mounted, setMounted] = useState(false);
	const pageTitle = title ? `${title} · Wishbox` : defaultTitle;
	const pageDescription = description || defaultDescription;
	const ogImage = `${webLink}assets/icon/icon_rainbow_lg.png`;

	useEffect(() => setMounted(true), []);

	useEffect(() => {
		if (!mounted) return;
		const id = window.location.hash.replace(/^#/, "");
		if (!id) return;
		requestAnimationFrame(() => {
			document.getElementById(id)?.scrollIntoView();
		});
	}, [mounted]);

	return (
		<>
			<Head>
				<title>{pageTitle}</title>
				<meta name="description" content={pageDescription} />
				<meta name="viewport" content="width=device-width, initial-scale=1.0" />
				<meta name="keywords" content="wishbox 2.0, savings app, wishbox, budget, expense tracker, finance, money management, iPhone, Android, iPad, Mac, Apple Watch, Wear OS, local-first, AI assistant, collaboration, iCloud sync, labeled savings" />
				<meta name="author" content="Kostas Filios" />
				<meta name="theme-color" content="#2572b5" />
				<link rel="icon" href="/favicon.ico" />
				<link rel="canonical" href={webLink} />
				<link rel="apple-touch-icon" href="/assets/icon/icon_rainbow_lg.png" />
				<meta name="apple-itunes-app" content={`app-id=${APP_STORE_ID}`} />
				<meta property="og:type" content="website" />
				<meta property="og:site_name" content="Wishbox" />
				<meta property="og:title" content={pageTitle} />
				<meta property="og:description" content={pageDescription} />
				<meta property="og:url" content={webLink} />
				<meta property="og:image" content={ogImage} />
				<meta property="og:image:width" content="1024" />
				<meta property="og:image:height" content="1024" />
				<meta property="og:locale" content="en_US" />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content={pageTitle} />
				<meta name="twitter:description" content={pageDescription} />
				<meta name="twitter:image" content={ogImage} />
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
				/>
			</Head>
			<Navbar />
			<div>{children}</div>
			<Footer />
		</>
	);
}
